import axios from 'axios';
import { setupAuthInterceptors } from './authInterceptor';
import { extractErrorMessage } from '../utils/errorHandler';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://accurix-backend-zq4b.onrender.com/api/v1';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

setupAuthInterceptors(apiClient);

export const getCompanyProfile = async (companyId) => {
  try {
    const response = await apiClient.get(`/company/${companyId}/`);
    
    // Handle array or object responses
    const company = Array.isArray(response.data) ? response.data[0] : response.data;
    return company;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};

export const updateCompanyProfile = async (companyId, data) => {
  try {
    const response = await apiClient.patch(`/company/${companyId}/`, data);
    
    const company = Array.isArray(response.data) ? response.data[0] : response.data;
    return company;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};

export const deleteCompanyProfile = async (companyId) => {
  try {
    const response = await apiClient.delete(`/user/delete/`);
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};
